var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { useMemo } from 'react';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import useNavigateWithLocationCheck from '@/hooks/useNavigateWithLocationCheck';
import useNavigation from '@/navigation/useNavigation';
import { useCheckAuth } from '@/utils/checkAuth';
import PlaceReviewSummaryInfo from '../../PlaceDetailScreen/components/PlaceReviewSummaryInfo';
import PlaceVisitReviewInfo from '../../PlaceDetailScreen/components/PlaceVisitReviewInfo';
import { EmptyStateCard } from '../components/AccessibilityInfoComponents';
export default function V2ReviewTab({ reviews, place, isAccessibilityRegistrable: _isAccessibilityRegistrable, }) {
    const navigation = useNavigation();
    const checkAuth = useCheckAuth();
    const { navigateWithLocationCheck, LocationConfirmModal } = useNavigateWithLocationCheck();
    // 최신순 정렬
    const sortedReviews = useMemo(() => [...reviews].sort((a, b) => { var _a, _b, _c, _d; return ((_b = (_a = b.createdAt) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 0) - ((_d = (_c = a.createdAt) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : 0); }), [reviews]);
    const handleReviewPress = () => {
        checkAuth(() => __awaiter(this, void 0, void 0, function* () {
            yield navigateWithLocationCheck({
                targetLocation: place.location,
                placeName: place.name,
                address: place.address,
                type: 'place',
                onNavigate: () => {
                    navigation.navigate('ReviewForm/Place', {
                        placeId: place.id,
                    });
                },
            });
        }), undefined, '앱에서 방문 리뷰를 작성해보세요');
    };
    if (reviews.length === 0) {
        return (_jsxs(EmptyStateWrapper, { children: [_jsx(EmptyStateCard, { title: '아직 등록된 방문 리뷰가 없어요🥲', description: '방문 리뷰는 공간 이용 여부를\n결정할 수 있는 중요한 정보에요!', buttonText: "\uBC29\uBB38 \uB9AC\uBDF0 \uC791\uC131\uD558\uAE30", onPress: handleReviewPress, elementName: "v2_review_tab_empty_write" }), LocationConfirmModal] }));
    }
    return (_jsxs(Container, { children: [_jsx(Section, { children: _jsx(SectionTitle, { children: "\uBC29\uBB38 \uB9AC\uBDF0" }) }), _jsxs(Content, { children: [_jsx(PlaceReviewSummaryInfo, { reviews: sortedReviews, placeId: place.id, placeName: place.name, placeLocation: place.location, placeAddress: place.address, hideWriteButton: true }), _jsx(Divider, {}), _jsx(PlaceVisitReviewInfo, { reviews: sortedReviews, placeId: place.id })] }), LocationConfirmModal] }));
}
const Container = styled.View `
  background-color: ${color.white};
`;
const Section = styled.View `
  padding: 20px;
  gap: 16px;
`;
const SectionTitle = styled.Text `
  font-family: ${font.pretendardSemibold};
  font-size: 18px;
  line-height: 26px;
  letter-spacing: -0.36px;
  color: ${color.gray90};
`;
const Content = styled.View `
  padding: 20px;
  gap: 32px;
`;
const Divider = styled.View `
  height: 1px;
  background-color: ${color.gray20};
`;
const EmptyStateWrapper = styled.View `
  flex: 1;
  background-color: ${color.gray5};
  padding-top: 20px;
`;
